import moment from 'moment';

export default function SRReportTypeController(
  $q,
  $rootScope,
  $scope,
  loaderService,
  reportsDataService,
  orgDataService,
  ssDialogService,
  generateReportDialog,
  editReportScheduleDialog
) {
  const vm = this;

  vm.isExpanded = false;

  vm.hasData = false;

  vm.filter = {
    reportOwner: "-1"
  };

  vm.reportInstances = [];
  vm.allReportInstances = [];

  vm.numberOfInstances = vm.reportType.numberOfInstances;
  vm.lastGeneratedDate = vm.reportType.lastGeneratedDate;

  vm.handleExpandReportType = handleExpandReportType;
  vm.handleRunReport = handleRunReport;
  vm.handleScheduleReport = handleScheduleReport;

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  $scope.$on(`reports.scheduledReports.reportType${vm.reportType.reportId}.scheduledReportInstanceDeleted`, (event, reportInstance) => { // eslint-disable-line max-len
    _handleRemoveReportInstance(reportInstance);
  });

  $scope.$on(`reports.scheduledReports.reportType${vm.reportType.reportId}.scheduledReportInstancesDeleted`, (event, reportInstance) => { // eslint-disable-line max-len
    _loadArchivedReportInstances();
  });

  $scope.$on(`reports.scheduledReports.updateReportInstancesReportOwner`, (event, obj) => { 
    vm.filter.reportOwner = obj.reportOwner;
    vm.reportInstances = _filterByReportOwner();

    if (vm.hasData) {
      _updateReportInstanceCounts();
    }
  });

  function handleExpandReportType() {
    if (vm.isExpanded) {
      vm.isExpanded = false;
      return;
    }

    if (vm.hasData) {
      vm.isExpanded = !vm.isExpanded;
    } else if (vm.reportType.numberOfSchedules > 0) {
      loaderService.showViewLoader = true;
      _refreshReportSchedules().then(() => {
        loaderService.showViewLoader = false;
        vm.isExpanded = !vm.isExpanded;
        vm.hasData = true;
      });
    }
  }

  function handleRunReport($event) {
    const dfdOpenPopout = $q.defer();

    loaderService.showViewLoader = true;
    reportsDataService.getReport(vm.reportType.reportGroupId).then((response) => {
      ssDialogService.dialogs.reports.generateReportsDialog = ssDialogService.alert(
        generateReportDialog.getOptions($event, {
          report: response.data,
          serviceId: vm.reportType.serviceId,
          reportGroupId: vm.reportType.reportGroupId,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.reports.generateReportsDialog);
      loaderService.showViewLoader = false;
      dfdOpenPopout.resolve();
    });

    return dfdOpenPopout.promise;
  }

  function handleScheduleReport($event) {
    const dfdOpenPopout = $q.defer();
    loaderService.showViewLoader = true;
    reportsDataService.getScheduledReport(vm.reportType.reportGroupId).then((getScheduledReportResponse) => {
      orgDataService.getReportRecipients().then((getReportRecipientsResponse) => {
        ssDialogService.dialogs.reports.editReportScheduleDialog = ssDialogService.alert(
          editReportScheduleDialog.getOptions($event, {
            schedule: {
              customerScheduleId: 0,
              report: getScheduledReportResponse.data,
              reportId: getScheduledReportResponse.data.reportId,
              reportGroupId: getScheduledReportResponse.data.reportGroups[0].reportGroupId,
              blackoutUntil: getScheduledReportResponse.data.reportGroups[0].blackoutUntil,
              saveByFileName: getScheduledReportResponse.data.saveByFileName,
              schedule: {
                scheduleType: 1,
                executionHour: 7,
                executionMinute: 30,
                executionAMPM: 0,
                onceExecutionDate: moment(),
              },
              delivery: {
                saveToInstitutionReports: true,
              }
            },
            reportRecipients: getReportRecipientsResponse.data.result,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.reports.editReportScheduleDialog);
        loaderService.showViewLoader = false;
        dfdOpenPopout.resolve();
      });
    });
    return dfdOpenPopout.promise;
  }

  /** ********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('reports.reportScheduleDeleted', (event, opt) => {
      if (opt.reportGroupId === vm.reportType.reportGroupId) {
        _refreshReportSchedules();
      }
    });
  }

  function _refreshReportSchedules() {
    const dfdRefresh = $q.defer();

    reportsDataService.getMyReportSchedules(vm.reportType.reportGroupId).then((response) => {
      vm.reportType.reportSchedules = [];
      if (response.data.recordCount > 0) {
        angular.extend(vm.reportType.reportSchedules, response.data.result);
      }

      if (response.data.recordCount !== vm.reportType.numberOfSchedules) {
        vm.reportType.numberOfSchedules = response.data.recordCount;
      }
      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }
  
  function _filterByReportOwner() {
    let _filteredReportInstances = [];

    if ((vm.allReportInstances === null) || (vm.allReportInstances.length === 0)) {
      _filteredReportInstances = vm.allReportInstances;
    } else {
      if (vm.filter.reportOwner !== "-1") {
        const _fris = [];
        R.forEach((reportInstance) => {          
          let _found = false;
              
          if (reportInstance.createdBy === vm.filter.reportOwner ) {
            _found = true;
          };

          if (_found) {
            _fris.push(reportInstance);
          }
        }, vm.allReportInstances);

        _filteredReportInstances = _fris;
      } else {
        _filteredReportInstances = vm.allReportInstances;
      }
    }
    
    return _filteredReportInstances;
  }

  function _handleRemoveReportInstance(reportInstance) {
    if (!reportInstance) {
      return;
    }

    if (vm.reportInstances.length <= 1) {
      // This reportType just lost its last reportInstance, so it should be removed
      vm.allReportInstances = [];
      $rootScope.$broadcast('reports.archivedReports.reportTypeEmpty', vm.reportType);
      vm.isExpanded = false;
      vm.hasData = false;
      return;
    }
    
    _remove(vm.allReportInstances);
    _remove(vm.reportInstances);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.reportInstanceId === reportInstance.reportInstanceId);
      if (pos === -1) return; // Can't find the item
      collection.splice(pos, 1);
    }

    // Update summary info
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
    vm.lastGeneratedDate = _getMaxDate(vm.reportInstances);
  }

  function _getMaxDate(reportInstances) {
    let maxDate = reportInstances[0].createDate;
    let maxDateObj = new Date(reportInstances[0].createDate);
    reportInstances.forEach((instance) => {
      if (new Date(instance.createDate) > maxDateObj) {
        maxDate = instance.createDate;
        maxDateObj = new Date(instance.createDate);
      }
    });
    return maxDate;
  }

  function _updateReportInstanceCounts() {
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
  }
}

SRReportTypeController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'loaderService',
  'reportsDataService',
  'orgDataService',
  'ssDialogService',
  'generateReportDialog',
  'editReportScheduleDialog',
];
